import type * as React from 'react';
import { put } from '@Domain/Api';
import type { RolePayload } from '@Application/Security/Roles/Actions/rolesFetched';
import roleUpdated, { type RoleUpdatedAction } from '@Application/Security/Roles/Actions/roleUpdated';
import roleUpdateFailed, {
	type RoleUpdateFailedAction,
} from '@Application/Security/Roles/Actions/roleUpdateFailed';
import type UpdateRole from '@Application/Security/Roles/Commands/UpdateRole';
import fetchRoles from '@Application/Security/Roles/fetchRoles';
import FetchRoles from '@Application/Security/Roles/Queries/FetchRoles';
import type { RolesFetchedAction } from '@Application/Security/Roles/Actions/rolesFetched';
import type { RolesFetchFailedAction } from '@Application/Security/Roles/Actions/rolesFetchFailed';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = RoleUpdatedAction | RoleUpdateFailedAction | RolesFetchedAction | RolesFetchFailedAction;

/** The response carries only the updated role, so the list is refetched; a failed refetch is ignored. */
export default (command: UpdateRole) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await put<RolePayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/roles/${command.roleId}`,
				command.toJSON(),
			);

			const action = roleUpdated(payload, command.accountId);
			dispatch(action);
			await fetchRoles(new FetchRoles(command.accountId))(dispatch).catch(() => undefined);

			return action;
		} catch (error) {
			const action = roleUpdateFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
